module.exports = __webpack_public_path__ + "img/cus_service.png";